"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leaf = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const Key_1 = require("@jsonjoy.com/ui/lib/1-inline/Key");
const Spoiler_1 = require("./Spoiler");
const font_1 = require("../../behavior/font");
const palette_1 = require("../../util/palette");
const ui_1 = require("@jsonjoy.com/ui");
const linkClass = (0, nano_theme_1.rule)({
    textDecoration: 'underline',
    textDecorationThickness: '1px',
    textUnderlineOffset: '4px',
    textDecorationColor: 'rgb(from currentColor r g b / 0.2)',
    '&:hover': {
        textDecorationColor: 'currentColor',
    },
});
const insClass = (0, nano_theme_1.rule)({
    bg: 'rgba(152,235,167,.3)',
    bxsh: '0 2px 0 0 rgba(152,225,167,.6)',
    td: 'none',
});
const delClass = (0, nano_theme_1.rule)({
    bg: 'rgba(240,190,190,.4)',
    bxsh: '0 2px 0 0 rgba(255,177,177,.5)',
    col: 'red',
});
const codeClass = (0, nano_theme_1.rule)({
    pd: '.14rem .42rem .22rem',
    bdrad: '.42em',
    ff: '"JetBrains Mono", "Fira Code", Menlo, monospace',
    fz: '.92em',
    fw: 500,
    ls: '-0.01em',
});
const Leaf = ({ attributes, children, leaf, text }) => {
    const styles = (0, context_1.useStyles)();
    const isInCodeBlock = !!(0, ui_1.useTrace)('isInCodeBlock');
    const dynamicCodeClass = (0, react_1.useMemo)(() => {
        return (0, nano_theme_1.rule)({
            bg: styles.g(0, 0.03),
            bd: `1px solid ${styles.g(0, 0.05)}`,
            bxsh: `inset 0 1px 0 ${styles.g(1, 0.16)}, 0 1px 2px ${styles.g(0, 0.06)}`,
            col: styles.g(0.08),
            '&:hover': {
                bg: styles.g(0, 0.04),
                bd: `1px solid ${styles.g(0, 0.16)}`,
                // bxsh: `inset 0 1px 0 ${styles.g(1, 0.44)}, 0 1px 2px ${styles.g(0, 0.06)}`,
                bxsh: `inset 0 1px 0 ${styles.g(1, 0.08)}, 0 1px 2px ${styles.g(0, 0.03)}`,
                col: styles.g(0.02),
            },
        });
    }, [styles]);
    const style = leaf.activeSelection
        ? { backgroundColor: styles.col.accent(0, 'bg-2') }
        : undefined;
    let content = children;
    if (!isInCodeBlock) {
        if (leaf.kbd)
            content = React.createElement(Key_1.Key, null, content);
    }
    if (leaf.ins)
        content = React.createElement("ins", { className: insClass }, content);
    else if (leaf.del)
        content = React.createElement("del", { className: delClass }, content);
    if (!isInCodeBlock) {
        if (leaf.bold)
            content = React.createElement("strong", { style: { fontWeight: 700 } }, content);
        if (leaf.italic)
            content = React.createElement("em", null, content);
    }
    if (leaf.underline)
        content = (React.createElement("u", { style: {
                textUnderlineOffset: 'var(--mutxt-uo, 3px)',
                textDecorationThickness: 'var(--mutxt-dt, auto)',
            } }, content));
    if (leaf.overline)
        content = React.createElement("span", { style: { textDecoration: 'overline' } }, content);
    if (leaf.strikethrough)
        content = React.createElement("span", { style: { textDecoration: 'line-through' } }, content);
    if (leaf.mark) {
        const slot = leaf.mark === true ? 'yellow' : leaf.mark;
        const dark = !styles.light;
        const markStyle = { background: (0, palette_1.markSlotBg)(slot, dark) };
        markStyle.color = (0, palette_1.markSlotFg)(slot, dark);
        content = React.createElement("mark", { style: markStyle }, content);
    }
    else {
        if (leaf.bg)
            content = React.createElement("span", { style: { backgroundColor: leaf.bg } }, content);
        if (leaf.fg)
            content = React.createElement("span", { style: { color: leaf.fg } }, content);
    }
    if (!isInCodeBlock) {
        if (leaf.spoiler)
            content = React.createElement(Spoiler_1.Spoiler, { text: text }, content);
        if (leaf.sup)
            content = React.createElement("sup", null, content);
        else if (leaf.sub)
            content = React.createElement("sub", null, content);
        if (leaf.code)
            content = React.createElement("code", { className: codeClass + dynamicCodeClass }, content);
    }
    const leafFontFamily = (0, font_1.fontFamilyOf)(leaf.font);
    if (leafFontFamily)
        content = React.createElement("span", { style: { fontFamily: leafFontFamily } }, content);
    const href = leaf.a?.href;
    if (href) {
        return (React.createElement("a", { ...attributes, className: linkClass, href: href, target: "_blank", rel: "noreferrer noopener", title: leaf.a?.title || href, style: style, onClick: (event) => {
                if (!(event.metaKey || event.ctrlKey))
                    event.preventDefault();
            } }, content));
    }
    return (React.createElement("span", { ...attributes, style: style }, content));
};
exports.Leaf = Leaf;
